import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m7 3 12.063.002.094.01.047.009.12.033.116.048.072.039.081.054.032.025.082.073 6.993 6.991c.16.156.267.366.294.6l.007.116L27 27a2 2 0 0 1-1.85 1.994L25 29H7a2 2 0 0 1-1.995-1.85L5 27V5a2 2 0 0 1 1.85-1.995zm11 1.999L7 5v22h18V12h-6a1 1 0 0 1-.993-.883L18 11zm2 1.415L23.585 10H20z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconDocuments = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconDocuments);
export default Memo;
